import { Pressable, SxProp, useDripsyTheme, View } from "dripsy";
import React from "react";

import { Icon } from "../icons/Icon";

interface UniHeaderButtonProps {
  icon: string;
  onPress: () => void;
  sx?: SxProp;
}

export const UniHeaderButton: React.FC<UniHeaderButtonProps> = (props) => {
  const { icon, onPress, sx } = props;
  const { theme } = useDripsyTheme();

  return (
    <Pressable onPress={onPress}>
      {({ pressed }) => {
        let iconStyle = { ...styles.base };
        return (
          <View sx={sx}>
            <Icon
              name={icon}
              style={iconStyle}
              height={30}
              width={30}
              color={
                pressed ? theme.colors.$primary : theme.colors.$iconDefault
              }
            />
          </View>
        );
      }}
    </Pressable>
  );
};

enum StyleName {
  base = "base",
}

const styles: Record<StyleName, SxProp> = {
  base: {
    height: 50,
    width: 50,
  },
};
